import { CHARACTER_WHITESPACE } from '../../../constants/common'
import {
  formatCalendarDate,
  getCalendarCapWarningText,
} from '../Calendar.utils'

function getCalendarFollowUpCapQuestion({ dayLoad, locale, t }) {
  return dayLoad.next_free_date
    ? t('Calendar.CapConfirmQuestionKey', {
        date: formatCalendarDate({ date: dayLoad.next_free_date, locale }),
      })
    : t('Calendar.CapConfirmQuestionNoFreeDayKey')
}

export function getCalendarFollowUpCapDescription({ dayLoad, locale, t }) {
  return [
    getCalendarCapWarningText({ dayLoad, locale, t }),
    getCalendarFollowUpCapQuestion({ dayLoad, locale, t }),
  ].join(CHARACTER_WHITESPACE)
}
